import { Chip as MantineChip, ChipProps as MantineChipProps } from '@mantine/core';
import { CSSProperties, ReactNode } from 'react';

export type ChipProps = {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  color?: MantineChipProps['color'];
  variant?: MantineChipProps['variant'];
  size?: MantineChipProps['size'];
  radius?: MantineChipProps['radius'];
  icon?: ReactNode;
  withCheckIcon?: boolean;
  children: ReactNode;
  title?: string;
  value?: string;
};

const Chip: React.FC<ChipProps> = ({
  checked,
  defaultChecked,
  onChange,
  disabled,
  color = 'green',
  variant = 'outline',
  size = 'md',
  radius = 'xl',
  icon,
  withCheckIcon = true,
  children,
  title,
  value,
}) => (
  <MantineChip
    checked={checked}
    defaultChecked={defaultChecked}
    onChange={onChange}
    disabled={disabled}
    color={color}
    variant={variant}
    size={size}
    radius={radius}
    icon={icon}
    title={title}
    value={value}
    style={
      withCheckIcon
        ? undefined
        : ({ '--chip-checked-padding': 'var(--chip-padding)' } as CSSProperties)
    }
    styles={
      withCheckIcon
        ? undefined
        : {
            iconWrapper: { display: 'none' },
            label: { paddingBlock: 0 },
          }
    }
  >
    {children}
  </MantineChip>
);

export default Chip;
